document.addEventListener('DOMContentLoaded', () => {
  const url = new URL(window.location.href);
  const hasVariantParam = url.searchParams.has('variant');

  /* ---------- 1. Default Box Size: 6 LB ---------- */
  if (!hasVariantParam) {
    const fieldset = Array.from(document.querySelectorAll('variant-selects fieldset'))
      .find(fs => fs.querySelector('legend')?.textContent.trim().toLowerCase() === 'box size');

    if (fieldset) {
      const radios = fieldset.querySelectorAll('input[type="radio"]');
      for (const radio of radios) {
        const label = fieldset.querySelector(`label[for="${radio.id}"]`);
        const labelText = label?.childNodes[0]?.textContent?.trim().toUpperCase();
        if (labelText === '6 LB') {
          if (!radio.checked && !radio.disabled) {
            radio.checked = true;
            radio.dispatchEvent(new Event('change', { bubbles: true }));
          }
          break; // found it, no need to keep looping
        }
      }
    }
  }

  /* ---------- 2. Default Appstle plan: Two Week Subscription ---------- */
  const TARGET_PLAN_VALUE = '2376663149';

  function applyAppstleDefault(container) {
    const target = container.querySelector(`input[name="selling_plan_radio"][value="${TARGET_PLAN_VALUE}"]`);
    if (target && !target.checked && !target.disabled) {
      target.checked = true;
      target.dispatchEvent(new Event('change', { bubbles: true }));
      return true;
    }
    return !!target; // element found (even if already correct) counts as "handled"
  }

  const existingWrapper = document.querySelector('.appstle_subscription_wrapper');

  if (existingWrapper && applyAppstleDefault(existingWrapper)) {
    // Already present on load — done, no observer needed.
  } else {
    const mountPoint = existingWrapper?.parentElement || document.body;

    const observer = new MutationObserver(() => {
      const wrapper = document.querySelector('.appstle_subscription_wrapper');
      if (wrapper && applyAppstleDefault(wrapper)) {
        observer.disconnect();
      }
    });

    observer.observe(mountPoint, { childList: true, subtree: true });
    setTimeout(() => observer.disconnect(), 10000); // hard stop, never runs indefinitely
  }
});